/**
 * author: duxin
 * date: 2020/4/23
 * describe:
 */

const en = {
    menu: {
        home: "Home",
        service: "Services",
        info: "Information",
        about: "About Us",
        job: "Join Us",
        contact: "Contact Us",
        lang: "中文",

        dm: "Data Management",
        biostatistics: "Biostatistics",
        sp: "Statistical Programming",
        pharmacovigilance: "Pharmacovigilance",
        cc: "Call Center",
        // auditing: "Quality Assurance & Audits",
        // patient: "Site & Patient Management",
        // drug: "Phase I Unit",
        // diagnosis: "Central Imaging",
        // medical: "Medical & Clinical Strategy",
        // food: "Global Business Affairs",
        // partner: "Investment / Partnership Database",

        company: "Company News",
        industry: "Share with you",
        book: "Reference Books",

        companyInfo: "Company Profile",
        children: "Subsidiaries",
    },
    home: {
        about: "About Us",
        content1: `Meta-Clinical`,
        content11: `Professional Biometrics Services Related to Clinical Trials`,
        content2: `Meta Clinical Technology Co. Ltd is a Contract Research Organization (CRO) with its focus on outsourced biometrics business related to clinical trials sponsored by domestic or global pharmaceutical companies and wholly owned subsidiary of Clinical Service Center Co., Ltd. which is a full service CRO in China. It has offices located in Shanghai, Xi’an, Shenyang, Nanjing, Chengdu, Suzhou and Taipei in China. So far, Meta-Clinical has provided the service of data management, biostatistics, statistical programming, pharmacovigilance and call center...`,
        // content3: "By providing quality-oriented services at reasonable prices, clinical service centers have rapidly become one of the leading cros in China. Our customers and partners include pharmaceutical, biotechnology and medical equipment, academic institutions and government organizations at home and abroad. We use advanced practice and technology, treatment expertise and commitment to quality to help customers and partners complete their clinical projects, to accelerate the delivery of safe and effective treatment methods, and to maximize the return on their R & D investment, so as to build our rich experience in clinical research. Many medical majors, such as oncology, cardiovascular and so on.",
        values: "Our Core Value",
        valuesText: "Quality, Integrity, Productivity, Care for People",
        mission: "Our Mission",
        missionText: "Help Support research and development of medicinal products to make human beings healthier based on quality-oriented services",
        vision: "Our Vision",
        visionText: "Quality Data, Seamlessly Executed",

        seeMore: "See More",

        services: "Our Services",

        information: "Our Information",

        banner1: "We Are All Followers For Global Criteria",
        banner2: "Quality Data, Seamlessly Executed",
    },
    about: {
        content1: "Meta Clinical Technology is one of the wholly-owned subsidiaries of Clinical Service Center Co., LTD. and mainly provides clinical data management, biostatistics, statistical programming and other services. Currently, we have hundreds of professionals in data management and statistical analysis, and we can customise our data management and statistical services according to the needs of our clients."
        + "In accordance with international standards, META provides clients with systematic services in data management with advanced technologies, processes and professional teams. All services are provided in accordance with domestic regulatory guidelines, ICH-GCP and US FDA 21 CFR Part 11 rules, ensuring that clients are provided with the most accurate, timely and credible clinical trial data." + 
        "Since its inception, Meta has participated in hundreds of clinical trials, undergone more than 100 national bureau inspections, and assisted many companies, including leading traditional and innovative pharmaceutical companies, in completing their drug launches. The team is familiar with the design and execution of domestic and international clinical trials, and is well versed in domestic and international drug regulations and implementation rules. Many experts in the team have participated in the formulation of many international guidelines and the writing of domestic guidelines, and have accumulated rich experience in clinical trial data management and statistics in many medical fields, which can help clients complete the marketing of their drugs in a faster, more stable and better way.",
        content2: ``,
        journey: "Our History",

        history2019:"Taipei office was established, and Meta Clinical is motivated to continuously provide high quality and professional services to our customers and partners around the world.",
        history2018:"Meta Clinical Technology Co. Ltd(Nanjing) a wholly-owned subsidiary of Clinical Service Center; was established, gradually realizing the combination of strengths.",
        history2017:"The Shanghai Pudong office was opened, the Shanghai office team members increased to about 20 people, and the Shanghai office was officially operated as the main office area of Meta.",
        history2016:"The Shenyang office was established in October, with 10 members of the initial Shenyang team, and the Data Management team is gradually growing.",
        history2014:"Meta Clinical Technology Co. Ltd was established in Xi'an Shaanxi Province,China,with the main business scope including Data Management, Biostatistics, etc.",

        honor: "Awards & Recognitions",
        honor2014: ["Top Quality Clinical Team of the Year. Awarded by: Chinese Academy of Medical Sciences Cancer Hospital"],
        honor2015: ["Top Quality Clinical Team of the Year. Awarded by: Chinese Academy of Medical Sciences Cancer Hospital"],
        honor2016: ["Meta-Clinical: China Innovation and Entrepreneurship (Northwest Division). First Prize", "Top Quality Clinical Team of the Year. Awarded by: Chinese Academy of Medical Sciences Cancer Hospital"],
        honor2018: ["High-tech enterprise"],
        honor2019: ["Became a member of the China Pharmaceutical Industry Association (CPIA)", "1 person from CSC was hired as the deputy head of the early clinical trial research group for the First Chinese and Western Medicine Integrated Oncology Professional Committee of the China Anti-Cancer Association, and 7 were hired as members.", "1 person was hired as a member of the first clinical research committee"],

        team: "Our Team",

        meta: "Meta Clinical Technology Co. Ltd, wholly owned subsidiary of CSC, providing a full-range of Clinical Data Management, Statistical Analysis, Statistical Programming, Pharmacovigilance and Call Center services to both domestic and global pharmaceutical companies.",
        metaName: "Meta Clinical Technology Co. Ltd",
        CRiC: "CRiC Beijing Clinical Research Co. Ltd. (CRiC), wholly owned subsidiary of CSC, is a domestic professional clinical research Site Management Organization (SMO). Our Clinical Research Coordinators (CRC) are strategically distributed in more than 50 cities across the country, covering more than 300 hospitals. We have formed strategic partnerships with many of the hospitals. We always put quality first, and are committed to seeking solutions for on-site management of clinical trials in China. We have a wide range of experience in many therapeutic areas including , but not limited to, Oncology, Endocrinology, Respiratory and Cardiovascular. Since establishment, all CRiC staff have been continuously pioneering and innovating, adhering to the principle of high efficiency and quality, and actively cooperated with sponsors and investigators to complete each project. As of today, we have 300+ completed and ongoing projects, 30% of the projects are international multi-center projects. Most of the projects have been audited by authoritative organizations and provincial drug regulatory authorities, on-site inspection by NMPA.",
        CRiCName: "CRiC Beijing Clinical Research Co. Ltd.",
        sz: "Clinical Service Center (Suzhou) Co. Ltd is a wholly owned subsidiary of CSC, providing early phase clinical monitoring, medical writing, medical monitoring, medical strategy, independent third-party image assessment, and regulatory affairs in both China and the U.S.  Through our highly stable and professional team we continuously provide high-quality services to our clients and help them realize their goals for product development by taking full advantage of our resources and local knowledge in various areas.",
        szName: "Clinical Service Center (Suzhou) Co. Ltd",

        more: "Learn More",
        culture: "Company Culture",
        honor: "Honor"
    },
    common: {
        companyName: "Meta Clinical Technology Co. Ltd",
        companyInfo: "Company Profile",
        children: "Filiale",
    },
    // 联系我们
    contact: {
        addBJ:'Beijing Office',
        welcome:'Welcome letter',
        nameBJ: 'Beijing Headquarters',
        regionalOffice:'Regional Office',
        infoBJ: 'Suite 302,Building C01-Main Building, Dream 2049 Industrial Park, 4 Sanjianfang Nanli, Chaoyang District, Beijing, 100024, P.R. China',
        nameSH: 'Shanghai Office',
        infoSH: 'Room A,20th Floor-Oriental International Technology Building,No. 58 Xiangcheng Road, Pudong New Area, Shanghai, 200122, P.R. China\nPhone：021-64729901',
        nameCD: 'Chengdu Office',
        infoCD: '2907 Aerospace Science and Technology Building, No.7 Xinguanghua Street, Jinjiang District, Chengdu City, Sichuan Province 610041, P.R. China',
        nameGZ: 'Guangzhou Office',
        infoGZ: 'Room 1506, 510030, Block B, China International Center, No. 33, Zhongshan 3rd Road, Yuexiu District, Guangzhou City, 510030,P.R.China',
        nameXiAn: `Xi'an Office`,
        infoXiAn: 'Room 2308, Century Future Center, Huijing International Plaza, Southeast Corner of Fengcheng 3rd Road & Taihua North Road, Weiyang District, Xi’an City',
        nameSY: 'Shenyang Office',
        infoSY: 'Room 1009, Ping An Fortune Center, No. 21, Beiling Street, Huanggu District, Shenyang City, Liaoning Province, P.R. China.',
        nameNJ: 'Nanjing Office',
        infoNJ: 'Room 307, Kechuang Building, No.3 Gutan Avenue, Gaochun Economic Development Zone, Jiangsu Province,211300,P.R,China\nPhone:025-66903899',
        nameSB: 'NanJing Office',
        infoSB: 'Rooms 2303-2306, Dadi Building, No. 56 Huaqiao Road, Gulou District, Nanjing City',
        nameTJ: 'Tianjin Office',
        infoTJ: 'Room 907, Building A, Financial Street Center, Ronghui Plaza, Nankai District, Tianjin',
        nameSZ: 'Suzhou Office',
        infoSZ: 'A211, 2nd Floor, Jiangsu Institute of Biomedical Sciences, Chinese Academy of Sciences, 108 Yuxin Road, Industrial Park, Suzhou City, Jiangsu Province, 215000，P.R. China\nPhone:0512-67990267',
        nameTB: 'Taipei Office',
        infoTB: '7F., No. 2, Sec. 3, Minsheng E. Rd., Zhongshan Dist., Taipei City 104, Taiwan (R.O.C.)',
        nameHZ: 'Hangzhou Office',
        infoHZ: 'Room B005, 12th Floor, Building 4, Clarity Plaza B, Hengqi Business Center, No. 177 Huayuandou Street, Shangcheng District, Hangzhou',
        nameWH: 'Wuhan Office',
        infoWH: 'No.02, 22nd Floor, Building T1, Nanguo Center,Jianghan North Road, Jianghan District, Wuhan City',
        nameZZ: 'Zhengzhou Office',
        infoZZ: 'Unit 308, 3rd Floor, West Gate, Building 6, Jincheng Times Square, No. 133 Yaozhai Road, Jinshui District, Zhengzhou City',
        locateMe: 'Locate Me',
        geolocationNotSupported: 'Your browser does not support geolocation',
        permissionDenied: 'Location permission denied',
        positionUnavailable: 'Unable to get your location',
        geolocationTimeout: 'Location request timed out',
        geolocationError: 'Failed to get location, please try again later'
    },
    fromData: {
        name: 'Your Name',
        position: 'Your Position',
        company: 'Your Company Name',
        email: 'Your Email Address',
        phone: 'Your Telephone',
        productName: 'Product Name',
        productType: 'Type of Product',
        origin: 'Country of Origin',
        newOrGeneric: 'Innovative or Generic',
        cureSphere: 'Therapeutic Area',
        indication: 'Indication',
        indicationZh: 'Intended Indications for China',
        stage: 'Status or Phase of Development Outside of China',
        cooperativeIntention: 'Partnership Interests',
        remark: 'Any other information you would like to provide',
        more: 'More',
        moreText: `* In order to assist you find potential partners in China we may provide the above information (in part or in full) to third parties that are a potential match. By pressing “send” you agree to our Mutual Confidential Agreement by default. For further information, click here.`,
        btnText: 'Agree and Send',
        captcha: 'Captcha',
        captchaEmpty: 'Please enter the captcha',
        sendOk: 'Success',
        sendText: 'We will get in touch with you as soon as possible, thank you!',
        fromRules: 'Please fill in the correct information',
        error: 'Error',
        systemError: 'System Error',
        contact:'Cooperation Form'
    },
    help: {
        helpWays: 'How we can help',
        company: 'Cooperation & Partners',
        helpContent: 'Please fill in the form below in as much detail as possible so that we may identify the best matches for you.',
        area: 'Therapy area',
    },
    join:{
        values: 'Our Faith',
        quality: 'This world would become more vitality and healthier when the innovative integrations of science with new medical treatments are continuously endeavored',
        mission:'Our Vision',
        missionText: 'Quality Data, Seamlessly Executed',
        joinTitle:'Opportunities',
        find:"Find details",
        team:"Team Building",
        teamContent:"We respect every team member and promote a work culture that is \"simple and open, focused on execution, teamwork, and cultivating an entrepreneurial mindset that is able to embrace change.\" We encourage healthy and rich team activities and employee care. . Every year we organize at least one company-wide team building event and celebrate each major holiday together in each of our offices. In addition, we share gifts to each employee on their birthday and every quarter celebrate birthdays in-office, too. \n" +
            "Each department will also regularly arrange team building events, and are constantly committed to creating a more relaxed and harmonious, creative and passionate working environment and team atmosphere.",

        career:"Career Path in CSC",
        careerContent:`Forward thinking: Direction is more important than effort, ability is more important than knowledge, health is more important than performance, life is more important than a diploma, emotional intelligence is more important than IQ——President of Tsinghua University
CSC provides a clear and open career development path for every employee, with options to suite every individuals’ requirements.
Clear career development path: From junior clinical data management up to department director. `,

        talent :"Talent Cultivation",
        talentContent:`CSC has established a professional talent management and development system to ensure efficient and comprehensive training is afforded to all employees across all levels. Utilizing both online and offline platforms through our “CSC Academy” and “CSC Online College” we are able to provide each employee the opportunity to continuously improve his/her hard and soft skills, and help them reach their career goals.
We cooperate with the China Pharmaceutical University to train post-graduate students in the field of clinical pharmacy, and co-organize training programs for the U.S. clinical auditor certification to continuously deliver clinical trial professionals to Chinese pharmaceutical R&D companies and related institutions.`,
        application: 'Apply for a position',
        more: 'MORE',
        jobDetail: 'Job detalis',
        jobDuties: 'Job duties',
        jobRequirements: 'Job requirements',
        welfare: 'Welfare info',
        applicantName: 'name',
        gender: 'gender',
        birthday: 'birthday',
        mobile: 'mobile',
        email: 'email',
        education: 'education',
        academy: 'academy',
        city: 'city',
        clinicalExperience: 'clinicalExperience',
        file: 'CV',
        male: 'male',
        female: 'female',
        yes: 'yes',
        no: 'no',
        selectFile: 'Select file',
        desc: 'Only upload pdf files',
        submit: 'submit',
        clinical: 'Clinical Service Center',
        meta: 'Meta Clinical Technology Co.Ltd',
        cric: 'CRiC Beijing Clinical Research Co.Ltd',
        specialist: 'College',
        undergraduate: 'Undergraduate',
        master: "Master's degree",
        doctor: 'Doctoral students',
    },
    // 底部
    footer:{
        company:'Copyright © 2020 Meta Clinical Technology Co. Ltd.  All rights reserved ',
        compangCode: '沪ICP备2024102626号-1',
        tel:'Tel: 021-64729901/02/03',
        fax:'Fax: 6020',
        email:'Email: bd@meta-clinical.com',
        // web:'WEB: www.clinicalservice.cn',
        address:'Address: Room A,20th Floor-Oriental International Technology Building,No. 58 Xiangcheng Road,Pudong New Area, Shanghai, 200122, P.R. China',
        code:'P.R. China: 200031',
        szName:"Clinical Service Center (Suzhou) Co. Ltd",
    },
    // 媒体及投资者关系
    media: {
        mediaInvestor: "Media and investor relations",
        submit: "Submit",
        reset: "Reset",
        SJob: "Experienced Hire",
        CJob: "Campus Recruitment",
        InternJob: "Intern Recruitment",
        reJob: "Job Recruitment",
        contactWay: "Contact Details",
    }
};
export default en
